import { useMemo } from 'react'
import { InterviewAnswerFeedback } from 'builder/modules/interview/types'
import { useMediaQueries } from 'builder/hooks/useMediaQueries'
import LockIcon from '../../assets/LockIcon'
import { Container, Paywall, PaywallText, Row } from './styles'
import { CardFeedback, CardWithIdeal, SkeletonCard } from './components/Card/Card'
import { processedBlurCard } from './processedBlurCard'

interface Props {
  feedback: InterviewAnswerFeedback | undefined
  isUserPremium: boolean
}

export const CardSection = ({ feedback, isUserPremium }: Props) => {
  const { isPhone } = useMediaQueries()
  const cards = useMemo(() => {
    let results = (feedback?.ai_output || []).filter(
      criteria => criteria.section === 'areas_for_improvement',
    )

    let length = results.length
    // For the mobile version,  if we have 3 or 1 cards, then we show 2 cards or nothing
    if (isPhone && length % 2 === 1) {
      length--
    }
    results = results.slice(0, length)

    if (!isUserPremium) {
      results = processedBlurCard(results)
    }

    return results
  }, [feedback?.ai_output, isPhone, isUserPremium])

  const renderCards = () => {
    if (!feedback) {
      return (
        <>
          <SkeletonCard />
          <SkeletonCard />
          <SkeletonCard />
          <SkeletonCard />
        </>
      )
    }

    if (!isPhone && cards.length <= 2) {
      return (
        <Container>
          {cards.map(card => (
            <Row key={card.headline}>
              <CardWithIdeal {...card} blur={card.blur?.quantitative} />
              <CardFeedback {...card} blur={card.blur?.describe} />
            </Row>
          ))}
        </Container>
      )
    }

    return (
      <Container>
        <Row>
          {cards.map(card => (
            <CardWithIdeal key={card.headline} {...card} blur={card.blur?.quantitative} />
          ))}
        </Row>
        {!isPhone && (
          <Row>
            {cards.map(card => (
              <CardFeedback key={card.headline} {...card} blur={card.blur?.describe} />
            ))}
          </Row>
        )}
      </Container>
    )
  }

  return (
    <div
      style={{
        position: 'relative',
      }}
    >
      <Container>{renderCards()}</Container>
      {(!isPhone || (isPhone && cards.length >= 2)) && !isUserPremium && cards.length > 1 && (
        <Paywall $position="absolute">
          <LockIcon />
          <PaywallText>Fix your weak spots with experts insights</PaywallText>
        </Paywall>
      )}
    </div>
  )
}
